import useScrollReveal from "@/hooks/useScrollReveal";

export default function BrandBanner() {
  const ref = useScrollReveal();
  return (
    <section
      data-testid="brand-banner"
      className="bg-[#0A0A0A] text-white border-t border-b border-white/5"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto py-20 md:py-28 text-center">
        <div ref={ref} className="reveal-on-scroll">
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#A3A3A3] mb-8">
            TI · DATOS · Y · SISTEMAS
          </div>
          <div className="brand-crt-wrap">
            <span
              className="brand-crt"
              style={{ fontSize: "clamp(4rem, 16vw, 14rem)" }}
              data-testid="brand-banner-text"
            >
              WOK<span className="font-extrabold lowercase tracking-tight"> center</span>
            </span>
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#525252] mt-10 max-w-2xl mx-auto leading-relaxed">
            Software · Mobile · Inteligencia Artificial — Construido con rigor desde
            México para Latinoamérica.
          </div>
        </div>
      </div>
    </section>
  );
}
